function getResponseErrors(data) {
	let errors;

	try {
		errors = data.errors || [];
		errors = [ ...errors, ...(data.messages || []) ];
	} catch(error) {
		errors = [ error.message ];
	}

	console.log(errors);

	return errors || [];
}


export default getResponseErrors;
